import React from 'react';
import { ArrowRight } from '../icons';
import { IMG } from '../data/constants';

const Learners = ({ t, setPage }) => {
  const slugs = ['preschool', 'primary-school', 'middle-school', 'senior-school'];

  return (
  /* full-width bg */
  <div className="w-full bg-white">
    {/* max-width content */}
    <div className="max-w-[1440px] mx-auto px-5 lg:px-[120px] pt-[88px] h-auto lg:h-[580px] pb-[88px] lg:pb-0 box-border flex flex-col gap-12">

      <h2 className="m-0 font-heading font-medium text-[36px] lg:text-[46px] leading-[1.1] text-navy tracking-[-0.015em]">
        {t.learnTitle}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {t.levels.map((l, i) => (
          <a
            key={l.title}
            className="lcard relative block h-[282px] overflow-hidden rounded-[8px] shadow-md hover:shadow-lg transition-shadow duration-300"
            style={{ background: 'linear-gradient(160deg, #dbe8f0 0%, #b3cde0 100%)' }}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (setPage) {
                setPage(slugs[i]);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
            aria-label={`${l.title}, ${l.grade}`}
          >
            {/* Image */}
            <img src={IMG.level[i]} alt="" className="absolute inset-0 w-full h-full object-cover block" />

            {/* Arrow badge */}
            <div className="absolute top-[14px] right-[14px] w-10 h-10 bg-white text-navy flex items-center justify-center">
              <ArrowRight className="arr" />
            </div>

            {/* Bottom band */}
            <div className="lband absolute left-0 right-0 bottom-0 box-border px-5 pt-4 pb-[18px] bg-navy border-t-[3px] border-t-gold text-white flex flex-col gap-1">
              <span className="font-heading font-semibold text-[20px] leading-[1.2]">{l.title}</span>
              <span className="text-sm text-white/90">{l.grade}</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  </div>
  );
};

export default Learners;
